import React from 'react';

interface SupportedCurrency {
    network: string;
    currency: string;
    min_deposit: number;
    max_deposit: number;
    is_enabled: boolean;
    icon_url?: string;
    provider_name: string;
}

interface CurrencySelectorProps {
    currencies: SupportedCurrency[];
    selectedCurrency: string;
    onCurrencyChange: (currency: string) => void;
    disabled: boolean;
    loading?: boolean;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
    currencies,
    selectedCurrency,
    onCurrencyChange,
    disabled,
    loading = false,
}) => {
    return (
        <div>
            <label htmlFor="currencySelect" className="block text-sm font-semibold text-gray-700 mb-3">
                Currency
            </label>
            <div className="relative">
                <select
                    id="currencySelect"
                    value={selectedCurrency}
                    onChange={(e) => onCurrencyChange(e.target.value)}
                    disabled={disabled || loading}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all duration-200 bg-white appearance-none cursor-pointer hover:border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-50"
                >
                    <option value="">{loading ? 'Loading currencies...' : 'Select a currency'}</option>
                    {currencies.map((currency) => (
                        <option key={currency.currency} value={currency.currency}>
                            {currency.currency}
                        </option>
                    ))}
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    {loading ? (
                        <div className="w-5 h-5 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                    ) : (
                        <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CurrencySelector;